import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { filterOutRequestExtraParameters, handleApiRequestSuccessData, handleRequestError } from '@jove-frontend/uikit';
import { isArray } from 'lodash';
import qs from 'qs';
import { api } from '../index';
export var apiGetBrokerExternalQuoteActivityFeedList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get("/brokers/broker-quote/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/activity_feeds"));

          case 3:
            res = _context.sent;
            handleApiRequestSuccessData(res);
            return _context.abrupt("return", [res.data]);

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", handleRequestError(_context.t0));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));

  return function apiGetBrokerExternalQuoteActivityFeedList(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var apiApproveUpdateBrokerQuotePricePremium = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.patch("/quotes_plus/approve-override-premium/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId), payload);

          case 3:
            res = _context2.sent;
            handleApiRequestSuccessData(res);
            return _context2.abrupt("return", [res.data]);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", handleRequestError(_context2.t0));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));

  return function apiApproveUpdateBrokerQuotePricePremium(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiDeclineUpdateBrokerQuotePricePremium = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.patch("/quotes_plus/decline-override-premium/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId));

          case 3:
            res = _context3.sent;
            handleApiRequestSuccessData(res);
            return _context3.abrupt("return", [res.data]);

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", handleRequestError(_context3.t0));

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  return function apiDeclineUpdateBrokerQuotePricePremium(_x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiApplyForUpdateBrokerQuotePricePremium = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.patch("/quotes_plus/apply-override-premium/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId), filterOutRequestExtraParameters(payload));

          case 3:
            res = _context4.sent;
            handleApiRequestSuccessData(res);
            return _context4.abrupt("return", [res.data]);

          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError(_context4.t0));

          case 11:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 8]]);
  }));

  return function apiApplyForUpdateBrokerQuotePricePremium(_x4) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiAcceptBrokerQuote = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api.post("/admin/quotes_plus/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/accept"));

          case 3:
            res = _context5.sent;
            handleApiRequestSuccessData(res);
            return _context5.abrupt("return", [res.data]);

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", handleRequestError(_context5.t0));

          case 11:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 8]]);
  }));

  return function apiAcceptBrokerQuote(_x5) {
    return _ref5.apply(this, arguments);
  };
}();
export var apiDeclineBrokerQuote = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.post("/admin/quotes_plus/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/reject"));

          case 3:
            res = _context6.sent;
            handleApiRequestSuccessData(res);
            return _context6.abrupt("return", [res.data]);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", handleRequestError(_context6.t0));

          case 11:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 8]]);
  }));

  return function apiDeclineBrokerQuote(_x6) {
    return _ref6.apply(this, arguments);
  };
}();
export var apiGetQuotePromotionAllReleatedDetailInformation = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return api.get("/admin/quotes/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/promotion_info"));

          case 3:
            res = _context7.sent;
            handleApiRequestSuccessData(res);
            return _context7.abrupt("return", [res.data]);

          case 8:
            _context7.prev = 8;
            _context7.t0 = _context7["catch"](0);
            return _context7.abrupt("return", handleRequestError(_context7.t0));

          case 11:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 8]]);
  }));

  return function apiGetQuotePromotionAllReleatedDetailInformation(_x7) {
    return _ref7.apply(this, arguments);
  };
}();
export var apiGetQuotePromotionMemberList = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(payload) {
    var _res$data, res;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return api.get("/partner/promotions/".concat(payload === null || payload === void 0 ? void 0 : payload.promotionId, "/members"));

          case 3:
            res = _context8.sent;
            handleApiRequestSuccessData(res);

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data)) {
              res.data.data.forEach(function (item) {
                item.value = item.userId;
                item.label = "".concat(item.firstName, " ").concat(item.lastName);
              });
            }

            return _context8.abrupt("return", [res.data]);

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](0);
            return _context8.abrupt("return", handleRequestError(_context8.t0));

          case 12:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 9]]);
  }));

  return function apiGetQuotePromotionMemberList(_x8) {
    return _ref8.apply(this, arguments);
  };
}();
export var apiSendQuotePaymentEmail = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return api.post("/quotes_plus/send_payment_email/".concat(payload.quoteId), payload);

          case 3:
            res = _context9.sent;
            handleApiRequestSuccessData(res);
            return _context9.abrupt("return", [res.data]);

          case 8:
            _context9.prev = 8;
            _context9.t0 = _context9["catch"](0);
            return _context9.abrupt("return", handleRequestError(_context9.t0));

          case 11:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 8]]);
  }));

  return function apiSendQuotePaymentEmail(_x9) {
    return _ref9.apply(this, arguments);
  };
}();
export var apiGetQuoteRealPaymentLinkInfo = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return api.get("/quotes_plus/redirect_url/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId));

          case 3:
            res = _context10.sent;
            handleApiRequestSuccessData(res);
            return _context10.abrupt("return", [res.data]);

          case 8:
            _context10.prev = 8;
            _context10.t0 = _context10["catch"](0);
            return _context10.abrupt("return", handleRequestError(_context10.t0));

          case 11:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 8]]);
  }));

  return function apiGetQuoteRealPaymentLinkInfo(_x10) {
    return _ref10.apply(this, arguments);
  };
}();
export var apiSendBrokerQuoteEmail = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return api.post("/quotes_plus/broker/send_quote_email/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId), payload);

          case 3:
            res = _context11.sent;
            handleApiRequestSuccessData(res);
            return _context11.abrupt("return", [res.data]);

          case 8:
            _context11.prev = 8;
            _context11.t0 = _context11["catch"](0);
            return _context11.abrupt("return", handleRequestError(_context11.t0));

          case 11:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 8]]);
  }));

  return function apiSendBrokerQuoteEmail(_x11) {
    return _ref11.apply(this, arguments);
  };
}();
export var apiGetBrokerQuoteAssigneeList = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(payload) {
    var _res$data2, res;

    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return api.get("/partner_invitations/broker/members/get_all?".concat(qs.stringify(filterOutRequestExtraParameters(payload), {
              arrayFormat: 'repeat'
            })));

          case 3:
            res = _context12.sent;
            handleApiRequestSuccessData(res);

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data)) {
              res.data.data = res.data.data.map(function (item) {
                item.value = item.id;
                item.label = "".concat(item.firstName, " ").concat(item.lastName);
                return item;
              });
            }

            return _context12.abrupt("return", [res.data]);

          case 9:
            _context12.prev = 9;
            _context12.t0 = _context12["catch"](0);
            return _context12.abrupt("return", handleRequestError(_context12.t0));

          case 12:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 9]]);
  }));

  return function apiGetBrokerQuoteAssigneeList(_x12) {
    return _ref12.apply(this, arguments);
  };
}();
export var apiDirectlyApproveUpdateQuotePrice = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            _context13.next = 3;
            return api.patch("/quotes_plus/force-override-premium/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId), payload);

          case 3:
            res = _context13.sent;
            handleApiRequestSuccessData(res);
            return _context13.abrupt("return", [res.data]);

          case 8:
            _context13.prev = 8;
            _context13.t0 = _context13["catch"](0);
            return _context13.abrupt("return", handleRequestError(_context13.t0));

          case 11:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 8]]);
  }));

  return function apiDirectlyApproveUpdateQuotePrice(_x13) {
    return _ref13.apply(this, arguments);
  };
}();